import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { select, Store } from "@ngrx/store";
import { map, Observable, of, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { SuccessDto } from "src/app/shared/models/success-dto";
import {
  invokeUpdateAdvertisingCampaignForLocation,
  updateAdCampaignDetails,
} from "src/app/store/advertisingCampaign/advertisingCampaign.actions";
import { AppStateInterface } from "src/app/store/appState.interface";
import { updateAdCampaignDetailsSelector } from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import { NgbModal, NgbProgressbarConfig } from "@ng-bootstrap/ng-bootstrap";
import {
  AdvertisingCampaignInterface,
  LocationWithAvailabilities,
} from "src/app/shared/models/advertising-campaigns/advertising-campaign.interface";
import { invokeLocationPartnersCompanyNames } from "src/app/store/locationPartner/actions/get-locations.actions";
import { locationPartnersComapyNamesSelector } from "src/app/store/locationPartner/location-partner.selectors";
import { catchServerErrorSelector } from "src/app/store/user/user.selectors";
import { catchServerError } from "src/app/store/user/user.actions";
import { RoleEnum } from "src/app/shared/models/user/role.interface";
import { JwtService } from "src/app/shared/services/jwt.service";
import { invokeFranchisedCompanyNamesByFranchise } from "src/app/store/franchise/franchise.action";
import { resultFranchisedCompanyNamesByFranchiseSelector } from "src/app/store/franchise/franchise.selectors";
import { HttpEvent, HttpEventType, HttpResponse } from "@angular/common/http";
import { ExtensionService } from "src/app/shared/services/extension/extension.service";
import { TranslateService } from "@ngx-translate/core";
import { uploadFileProgressSelector } from "src/app/store/file/file.selectors";
import {
  invokeUploadFileWithProgress,
  setFileName,
} from "src/app/store/file/file.actions";
import { environment } from "src/environments/environment";
import { CreateUpdateAdvertisingCampaignByLocationPartner } from "src/app/shared/models/advertising-campaigns/createUpdateAdvertisingCampaignByLocationPartner";
import { RoleOptionEnum } from "src/app/shared/enum/roleOptionEnum";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";

@Component({
  selector: "app-update-campaign-lp",
  templateUrl: "./update-campaign-lp.component.html",
  styleUrls: ["./update-campaign-lp-component.scss"],
})
export class UpdateCampaignLPComponent extends BaseComponent implements OnInit {
  form: FormGroup;
  @Input() ad: AdvertisingCampaignInterface;
  validate: boolean;
  showAlert: boolean = false;
  showProgress: boolean = false;
  uploadProgress: number = 0;
  files: File[] = [];
  showError: boolean = false;
  isShown: boolean = false;
  filename: string | null = null;
  uploadFile$: Observable<HttpEvent<any> | null | HttpResponse<any>>;
  submitted: boolean;
  update$: Observable<SuccessDto | null>;
  updated: string;
  isLPUser: boolean = true;
  isFranchiseUser: boolean = false;
  locationPartnersResult$: Observable<string[] | null>;
  locations: string[];
  loading: boolean = false;
  catchServerError$: Observable<boolean | null>;

  locationWithAvailabilities: LocationWithAvailabilities;

  userRole: RoleEnum;
  roleEnum = RoleEnum;

  listFranchised$: Observable<string[]>;
  optionEnum: RoleOptionEnum;
  constructor(
    private store: Store<AppStateInterface>,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private extensionService: ExtensionService,
    private translate: TranslateService,
    configPB: NgbProgressbarConfig,
    private jwtService: JwtService,
    private saveHistory: SaveUserHistoryService
  ) {
    super(store);
    configPB.max = 100;
    configPB.striped = true;
    configPB.animated = true;
    configPB.type = "primary";
    configPB.height = "20px";

    this.form = this.fb.group({
      title: [null, [Validators.required]],
      locations: [null, [Validators.required]],
      franchise: [null],
    });
    this.update$ = this.store
      .pipe(select(updateAdCampaignDetailsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.uploadFile$ = this.store
      .pipe(select(uploadFileProgressSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.locationPartnersResult$ = this.store
      .pipe(select(locationPartnersComapyNamesSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchServerError$ = this.store
      .pipe(select(catchServerErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.listFranchised$ = this.store
      .pipe(select(resultFranchisedCompanyNamesByFranchiseSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.userRole = this.jwtService.getRoleName(localStorage.getItem("token"));
  }

  ngOnInit(): void {
    this.isLPUser = this.userRole === RoleEnum.ROLE_LOCATION;
    this.isFranchiseUser = this.userRole === RoleEnum.ROLE_FRANCHISE;
    this.switchRoleToFetchAndSetLocations();

    this.filename = this.ad.videoLink;
    this.form.patchValue({ title: this.ad.title });
    this.form.patchValue({ franchise: this.ad.publisherCompanyName });
    this.filename = this.ad.videoLink;
    this.locationPartnersResult$.subscribe((data) => {
      if (data) {
        this.locations = data;
      }
    });
    this.loadImage().subscribe((i) => {
      const myFile = new File(
        [i],
        this.translate.instant("campaignDetails.video") + "-" + this.ad.title,
        {
          type: i.type,
        }
      );
      this.files.push(myFile);
    });
    this.uploadFile$.subscribe(
      (result: HttpEvent<any> | null | HttpResponse<{ filename: string }>) => {
        if (result?.type == HttpEventType.UploadProgress) {
          this.showProgress = true;
          const total = result?.total ?? 1;
          this.uploadProgress = Math.round((result.loaded / total) * 100);
        }
        if (result?.type == HttpEventType.Response) {
          this.filename =
            (result as HttpResponse<{ filename: string }>)?.body?.filename ??
            "";
          this.submitted = true;
          this.loading = false;
          this.store.dispatch(setFileName({ filename: null }));
          setTimeout(() => {
            this.showProgress = false;
          }, 2000);
        }
      }
    );

    this.catchServerError$.subscribe((result) => {
      if (result) {
        this.loading = false;
        this.store.dispatch(catchServerError({ serverError: null }));
      }
    });
    this.update$.subscribe((result: SuccessDto | null) => {
      if (result != null) {
        this.updated = result.message;
        this.store.dispatch(updateAdCampaignDetails({ successMessage: null }));
        this.close();
        this.loading = false;
      }
    });

    this.listFranchised$.subscribe((result) => {
      if (result) {
        this.locations = result;
      }
    });
  }
  loadImage(): Observable<Blob> {
    return of(environment.CDN_RELEAD + this.ad.videoLink).pipe(
      map((data) => {
        const blob = new Blob([data], {
          type: `video/${this.extensionService.getExtension(
            this.ad.videoLink
          )}`,
        });
        return blob;
      })
    );
  }

  update() {
    const locationPartnersValue = this.form.get("locations")?.value;
    const advertiserCampaign: CreateUpdateAdvertisingCampaignByLocationPartner =
      {
        title: this.form.get("title")?.value,
        videoLink: this.filename,
        franchiseCompanyName: this.ad.publisherCompanyName,
        locationPartners: Array.isArray(locationPartnersValue)
          ? locationPartnersValue
          : locationPartnersValue
          ? [locationPartnersValue]
          : [],
        optionEnum: this.optionEnum,
      };

    this.store.dispatch(
      invokeUpdateAdvertisingCampaignForLocation({
        hashedId: this.ad.advertisingCampaignHashedId,
        campaignDto: advertiserCampaign,
      })
    );
    this.uploadProgress = 0;
    this.showProgress = false;
    this.loading = true;

    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.PATCH,
      UserHistoryServicesEnum.CAMPAIGN_LOCATION_UPDATE
    );
  }
  onSelect(event: File[]) {
    if (event[0].size > 4194304) {
      this.showError = true;
      this.showProgress = false;
    } else {
      this.files.push(event[0]);
      this.isShown = true;
      const formData = new FormData();
      formData.append("file", this.files[0], this.files[0].name);
      this.store.dispatch(invokeUploadFileWithProgress({ file: formData }));
    }
  }
  onRemove() {
    this.files = [];
    this.filename = null;
  }
  clear() {
    this.onRemove();
    this.form.reset({
      title: "",
      description: "",
    });
  }
  close() {
    this.modalService.dismissAll();
  }

  switchRoleToFetchAndSetLocations() {
    switch (this.ad.publisherRole) {
      case RoleEnum.ROLE_FRANCHISE: {
        this.form.patchValue({ locations: this.ad.locationPartners });
        this.store.dispatch(
          invokeFranchisedCompanyNamesByFranchise({
            companyName: this.ad.publisherCompanyName,
          })
        );
        this.optionEnum = RoleOptionEnum.FRANCHISE;
        break;
      }
      case RoleEnum.ROLE_LOCATION: {
        this.form.patchValue({
          locations: this.ad.locationPartners?.[0] || null,
        });
        this.optionEnum = RoleOptionEnum.LOCATION_PARTNER;
        if (this.userRole === RoleEnum.ROLE_ADMIN) {
          this.store.dispatch(
            invokeLocationPartnersCompanyNames({ excludeFranchised: false })
          );
        }
        break;
      }
      default:
        break;
    }
    if (this.isFranchiseUser) {
      this.store.dispatch(
        invokeFranchisedCompanyNamesByFranchise({
          companyName: this.ad.publisherCompanyName,
        })
      );
      this.optionEnum = RoleOptionEnum.FRANCHISE;
    }
  }

  selectAllLocations(event: any) {
    if (event.target.checked)
      this.form.get("locations")?.setValue(this.locations);
    else this.form.get("locations")?.setValue(null);
  }

  isAllSelected() {
    const locations = this.form.get("locations")?.value ?? [];
    if (locations.length === this.locations.length) {
      return true;
    } else return false;
  }
}
